import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from './entity';

@JsonObject('LearningFilter')
export class LearningFilter extends Entity {
  @JsonProperty('title', [String])
  public title: string[] = [];
  @JsonProperty('complexity', [String])
  public complexity: string[] = [];
  @JsonProperty('tag', [String])
  public tag: string[] = [];
  @JsonProperty('machineType', [String])
  public machineType: string[] = [];
  @JsonProperty('isFavorite', [Boolean])
  public isFavorite: boolean[] = [];
  @JsonProperty('active', [Boolean])
  public active: boolean[] = [];
  @JsonProperty('orderBy', [String])
  public orderBy: string[] = [];
  @JsonProperty('direction', [String])
  public direction: string[] = [];
}
